import {InsightsData} from './campaignAnalytics.types';
import {MetricValue} from '../analytics/analytics.types';

import {CLSelectorOption} from 'common/src/components/Selectors/CLSelector/CLSelector.types';

const DEFAULT_INSIGHTS_DATA: InsightsData = {
  // General
  [MetricValue.Impressions]: 0,
  [MetricValue.Clicks]: 0,
  [MetricValue.ClickThroughRate]: 0,
  [MetricValue.Conversions]: 0,
  [MetricValue.ConversionRate]: 0,
  [MetricValue.EngagementThroughConversions]: 0,
  [MetricValue.ViewThroughConversions]: 0,
  // Video | Audio | Social
  [MetricValue.VideoQ1]: 0,
  [MetricValue.VideoQ2]: 0,
  [MetricValue.VideoQ3]: 0,
  [MetricValue.VideoComplete]: 0,
  [MetricValue.Skip]: 0,
  [MetricValue.VideoCompletionRate]: 0,
  // Finance
  [MetricValue.Sales]: 0,
  [MetricValue.CPM]: 0,
  [MetricValue.Cost]: 0,
  [MetricValue.Roas]: 0,
  [MetricValue.CPC]: 0,
  [MetricValue.CPA]: 0,
  // External
  [MetricValue.ExternalCost]: 0,
  [MetricValue.ExternalConversions]: 0,
  [MetricValue.ExternalCPM]: 0,
  [MetricValue.ExternalCPC]: 0,
  [MetricValue.ExternalTotalConversionRate]: 0,
  // Others
  [MetricValue.Engagements]: 0,
  [MetricValue.ClickThroughConversion]: 0,
  [MetricValue.Viewability]: 0,
  [MetricValue.ViewedImpressions]: 0,
};

const AUDIO_CAMPAIGN_VCR_PHRASE = 'LTR';

const generalInsightsMetrics = [
  MetricValue.Impressions,
  MetricValue.Clicks,
  MetricValue.ClickThroughRate,
  MetricValue.Conversions,
  MetricValue.ConversionRate,
  MetricValue.ClickThroughConversion,
];

const othersInsightsMetrics = [
  MetricValue.EngagementThroughConversions,
  MetricValue.ViewThroughConversions,
  MetricValue.CTCR,
  MetricValue.VTCR,
  MetricValue.ViewedImpressions,
];

const metricsWithCurrencySymbol = [
  MetricValue.Sales,
  MetricValue.CPM,
  MetricValue.Cost,
  MetricValue.CPC,
  MetricValue.CPA,
  MetricValue.ExternalCPM,
  MetricValue.ExternalCPC,
  MetricValue.ExternalCost,
  MetricValue.ExternalSales,
];

const metaClinchMetrics = [MetricValue.Reach];

const financeInsightsMetrics = [
  MetricValue.Sales,
  MetricValue.CPM,
  MetricValue.Cost,
  MetricValue.Roas,
  MetricValue.CPC,
  MetricValue.CPA,
];

const mediaInsightsMetrics = [
  MetricValue.VideoQ1,
  MetricValue.VideoQ2,
  MetricValue.VideoQ3,
  MetricValue.VideoComplete,
  MetricValue.Skip,
  MetricValue.VideoCompletionRate,
  MetricValue.VideoQ1Rate,
  MetricValue.VideoQ2Rate,
  MetricValue.VideoQ3Rate,
];

const externalInsightsMetrics = [
  MetricValue.ExternalCost,
  MetricValue.ExternalConversions,
  MetricValue.ExternalCPM,
  MetricValue.ExternalCPC,
  MetricValue.ExternalTotalConversionRate,
  MetricValue.ExternalRoas,
  MetricValue.ExternalSales,
];

const MANAGE_PRESETS_OPTION_ID = 0;

const managePresetsSelectOption: CLSelectorOption = {
  value: String(MANAGE_PRESETS_OPTION_ID),
  label: 'Manage Presets',
};

const insightsPalette = [
  '#2C7BE5',
  '#936EFE',
  '#31BDB5',
  '#00C2FF',
  '#FE6544',
  '#004DC0',
  '#CE80CF',
  '#0FCB71',
  '#CE1E88',
  '#FFB545',
];

const rationInsights = [
  MetricValue.ConversionRate,
  MetricValue.ClickThroughRate,
  MetricValue.ExternalTotalConversionRate,
  MetricValue.CTCR,
  MetricValue.VTCR,
];

export {
  AUDIO_CAMPAIGN_VCR_PHRASE,
  DEFAULT_INSIGHTS_DATA,
  externalInsightsMetrics,
  financeInsightsMetrics,
  MANAGE_PRESETS_OPTION_ID,
  managePresetsSelectOption,
  generalInsightsMetrics,
  mediaInsightsMetrics,
  insightsPalette,
  rationInsights,
  othersInsightsMetrics,
  metricsWithCurrencySymbol,
  metaClinchMetrics,
};
